module.exports = __webpack_public_path__ + "img/linkedin-sales-solutions.405e92c.jpg";